import { Link } from "react-router-dom";
import { useState } from "react";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const formData = new URLSearchParams();
    formData.append("email", email);

    try {
      await fetch("https://readdy.ai/api/form/d8h3pqsgel9neuvial7g", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      });
      setSubmitted(true);
      setEmail("");
    } catch {
      // silently handle
    }
  };

  return (
    <footer className="bg-secondary-50">
      <div className="px-6 md:px-10 py-16 md:py-20">
        <div className="max-w-[1280px] mx-auto">
          <div className="bg-background-50 rounded-2xl p-10 md:p-16">
            <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
              <div className="lg:w-1/4">
                <Link to="/" className="inline-block mb-4">
                  <span className="font-heading text-xl font-bold text-foreground-950 tracking-tight">
                    Quick<span className="text-accent-500">Prosthetics</span>
                  </span>
                </Link>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  The digital front door connecting lower limb amputees with
                  certified prosthetists. Simple intake, smart matching,
                  compassionate care.
                </p>
              </div>

              <div className="flex-1 grid grid-cols-2 md:grid-cols-3 gap-8">
                <div>
                  <h4 className="font-label text-xs uppercase tracking-widest text-foreground-500 font-semibold mb-5">
                    Platform
                  </h4>
                  <ul className="flex flex-col gap-3">
                    <li>
                      <a
                        href="#features"
                        className="text-foreground-600 hover:text-foreground-950 text-sm transition-colors"
                      >
                        How It Works
                      </a>
                    </li>
                    <li>
                      <a
                        href="#specialists"
                        className="text-foreground-600 hover:text-foreground-950 text-sm transition-colors"
                      >
                        Find a Specialist
                      </a>
                    </li>
                    <li>
                      <Link
                        to="/intake"
                        className="text-foreground-600 hover:text-foreground-950 text-sm transition-colors"
                      >
                        Start Intake
                      </Link>
                    </li>
                    <li>
                      <a
                        href="#testimonials"
                        className="text-foreground-600 hover:text-foreground-950 text-sm transition-colors"
                      >
                        Patient Stories
                      </a>
                    </li>
                  </ul>
                </div>

                <div>
                  <h4 className="font-label text-xs uppercase tracking-widest text-foreground-500 font-semibold mb-5">
                    Company
                  </h4>
                  <ul className="flex flex-col gap-3">
                    <li>
                      <a
                        href="#"
                        className="text-foreground-600 hover:text-foreground-950 text-sm transition-colors"
                      >
                        About Us
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="text-foreground-600 hover:text-foreground-950 text-sm transition-colors"
                      >
                        For Prosthetists
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="text-foreground-600 hover:text-foreground-950 text-sm transition-colors"
                      >
                        Careers
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="text-foreground-600 hover:text-foreground-950 text-sm transition-colors"
                      >
                        Contact
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="col-span-2 md:col-span-1">
                  <h4 className="font-label text-xs uppercase tracking-widest text-foreground-500 font-semibold mb-5">
                    Stay Connected
                  </h4>
                  <form
                    id="newsletter-form"
                    onSubmit={handleSubmit}
                    className="flex flex-col gap-3"
                    data-readdy-form=""
                  >
                    {submitted ? (
                      <p className="text-sm text-primary-600 font-medium py-3">
                        Thanks for subscribing! We will keep you updated.
                      </p>
                    ) : (
                      <>
                        <div className="flex flex-col sm:flex-row gap-2">
                          <input
                            type="email"
                            name="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Your email address"
                            className="flex-1 px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                            required
                          />
                          <button
                            type="submit"
                            className="bg-primary-500 text-background-50 px-5 py-2.5 rounded-lg text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                          >
                            Subscribe
                          </button>
                        </div>
                        <p className="text-foreground-500 text-xs">
                          Get tips, resources, and updates for your prosthetic
                          care journey.
                        </p>
                      </>
                    )}
                  </form>
                </div>
              </div>
            </div>

            <div className="mt-12 pt-8 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-6 text-xs text-foreground-500">
                <span>
                  &copy; {new Date().getFullYear()} QuickProsthetics. All rights
                  reserved.
                </span>
                <a
                  href="#"
                  className="hover:text-foreground-700 transition-colors"
                >
                  Privacy Policy
                </a>
                <a
                  href="#"
                  className="hover:text-foreground-700 transition-colors"
                >
                  Terms of Service
                </a>
                <a
                  href="#"
                  className="hover:text-foreground-700 transition-colors"
                >
                  HIPAA Notice
                </a>
              </div>
              <div className="flex items-center gap-4">
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:text-foreground-950 hover:bg-background-200 transition-colors cursor-pointer"
                >
                  <i className="ri-twitter-x-line"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:text-foreground-950 hover:bg-background-200 transition-colors cursor-pointer"
                >
                  <i className="ri-linkedin-fill"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
